const FILTERS_APP_VERSION_KEY = 'FILTERS_APP_VERSION';

const FILTER_KEY_PREFIXES = [
    'VEHICLESFILTER',
    'DRIVERSFILTER',
    'CHARGESFILTER-',
    'VISITSREPORTFILTER',
    'VEHICLESMILEAGEFILTER',
    'VEHICLESMANAGEMENTFILTER',
    'ALARMSFILTER',
    'ALARMSTRIGGERSFILTER',
    'ALERTSFILTER',
    'GEOFENCESLISTFILTER',
    'GEOFENCECHARGESFILTER-',
    'VERIFICATIONSFILTER',
    'RESERVATIONSFILTER',
    'REMINDERSFILTER',
    'VEHICLESGPSFILTER',
    'USERSFILTER',
    'IMPORT_CHARGES_FILTER',
    'ACCIDENTSFILTER-',
    'ROUTESFILTERORDERBY',
    'vehicle-maintenance-filters-',
    'vehicle-monthly-charges-filters',
    'vehicle-alerts-filters',
    'vehicle-verifications-filters-',
    'vehicle-dashboard-filters',
    'PARAMETERS_SEGMENTS_FILTER',
    'PARAMETERS_GENERIC_TYPES_FILTER',
    'PARAMETERS_DAMAGE_TYPE_FILTER',
    'PARAMETERS_DEVICES_FILTER',
    'PARAMETERS_BRANDS_FILTER',
    'PARAMETERS_MAINTENANCE_COMPONENT_FILTER',
    'PARAMETERS_MAINTENANCE_CONTRACT_TYPE_FILTER',
    'PARAMETERS_LOCALS_FILTER',
    'PARAMETERS_REMINDER_CATEGORIES_FILTER',
    'PARAMETERS_IDENTIFICATION_TAGS_FILTER',
    'PARAMETERS_SUPPLIERS_FILTER',
    'PARAMETERS_MODELS_FILTER',
];

const clearAllFilterCaches = () => {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && FILTER_KEY_PREFIXES.some(prefix => key.startsWith(prefix))) {
            keysToRemove.push(key);
        }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
};

const setAppVersion = (version: string) => {
    const storedVersion = localStorage.getItem(FILTERS_APP_VERSION_KEY);
    if (storedVersion !== version) {
        clearAllFilterCaches();
        localStorage.setItem(FILTERS_APP_VERSION_KEY, version);
    }
};

const FilterStorage = {
    setAppVersion,
};

export default FilterStorage;
